import { render, staticRenderFns } from "./kong.vue?vue&type=template&id=71dc6d62&scoped=true"
import script from "./kong.vue?vue&type=script&lang=js"
export * from "./kong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dc6d62",
  null
  
)

export default component.exports